import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Icon } from 'loyal-react'
import yn from 'yn'

import { UserProfileSubmenu } from './UserProfileSubmenu'

class UserProfile extends Component {
  constructor (props) {
    super()

    this.state = {
      hideValue: false,
      menuExpanded: false
    }

    this.onBlurLink = this.onBlurLink.bind(this)
  }
  onBlurLink = () => {
    setTimeout(() => {
      if (document.querySelectorAll('[data-profile-expanded="true"]').length > 0 && document.querySelectorAll('.profile-menu .link-profile:focus').length === 0) {
        this.toggleExpandMenu()
      }
    }, 300)
  }
  formatName = name => {
    return name.split(' ')[0]
  }

  formatPoints = (value) => {
    const decimal = Math.pow(10, this.props.decimalPlaces)

    const formated = Math.floor(parseFloat(value) * decimal) / decimal

    return (formated).toLocaleString('pt-br', {
      minimumFractionDigits: this.props.decimalPlaces || 0,
      maximumFractionDigits: this.props.decimalPlaces || 0
    })
  }

  hideValue = () => {
    window.localStorage.setItem('hideValue', !this.state.hideValue)
    this.setState({
      hideValue: !this.state.hideValue
    })
  }
  toggleExpandMenu = () => {
    this.setState({
      menuExpanded: !this.state.menuExpanded
    })
  }

  handleKeyEsc = (e) => {
    clearTimeout(this.state.timer)

    if (e.key === 'Escape') {
      this.setState({
        menuExpanded: false
      })

      document.getElementById('profile-menu').focus()
    }
  }

  render () {
    const hideValueStorage = yn(window.localStorage.getItem('hideValue'))
    let pointsValue = this.formatPoints(this.props.pointsValue) + ' ' + this.props.pointsName
    return (
      <div className='profile-menu profile zindex-high col-sm-4 col-xl-3 d-none d-sm-block px-2 py-1' data-profile-expanded={this.state.menuExpanded}>
        <div className='row align-items-center w-100 h-100 px-0'>
          <div className='col-12'>
            <div className='row align-items-center h-100 mx-0'>
              <div className='col color-brand-5 profile-infos txt-font-body txt-body-sm px-0 px-md-1'>
                <p className='txt-body-sm txt-left'>Olá, {this.formatName(this.props.userInfo.name)}!</p>
                {this.props.isLoading ? (
                  <p className='color-points-information txt-left'>Carregando pontuação</p>
                ) : (
                  <p className='row txt-title color-points-information txt-left pt-half'>
                    <div className='col-auto'>
                      <span onClick={() => this.hideValue()} className={`${hideValueStorage || this.state.hideValue ? 'd-none' : ''} fontSize20`}>{pointsValue}</span>
                      <div onClick={() => this.hideValue()} className={`pos-relative hidden-value bg-ui-3 radius ${!hideValueStorage && !this.state.hideValue ? 'd-none' : ''}`} />
                    </div>
                    { pointsValue.length <= 14 && <div className='col-auto d-flex align-items-center px-0'>
                      <a
                        href='javascript:void(0)'
                        role='button'
                        className='userprofile-hide-points d-inline-block'
                        aria-label={`${hideValueStorage || this.state.hideValue ? 'Exibir ' : 'Esconder'} pontuação`}
                        onClick={() => this.hideValue()}>
                        <span className='hide-absolute hide-points-menu'>{
                          hideValueStorage || this.state.hideValue
                            ? 'Exibir pontuação'
                            : 'Esconder pontuação'
                        }</span>
                        <Icon
                          iconName={hideValueStorage || this.state.hideValue ? 'icon_no_view' : 'icon_view'}
                          className={`icon-md w-100 ${hideValueStorage || this.state.hideValue ? 'pos-absolute' : 'pos-relative'} l-0 t-0`}
                        />
                      </a>
                    </div>
                    }
                  </p>
                )}
              </div>
              <div className='col-auto d-none d-sm-block profile-dropdown  px-0 px-md-1'>
                <button
                  id='profile-menu'
                  aria-expanded={this.state.menuExpanded}
                  aria-controls='profile-list'
                  onClick={this.toggleExpandMenu}
                  onBlur={() => this.onBlurLink()}
                  onKeyDown={(e) => this.handleKeyEsc(e)}
                  aria-label='Abrir menu do usuário'
                >
                  <Icon iconName='icon_down' className='icon-sm color-brand-5' />
                </button>
              </div>
            </div>
          </div>
        </div>
        <UserProfileSubmenu
          onBlurLink={this.onBlurLink}
          handleKeyEsc={this.handleKeyEsc}
        />
      </div>

    )
  }
}

UserProfile.propTypes = {
  isLoading: PropTypes.bool,
  userInfo: PropTypes.object,
  pointsValue: PropTypes.number,
  pointsName: PropTypes.string,
  decimalPlaces: PropTypes.number
}

const mapStateToProps = ({ oidc, balance, catalog }) => ({
  isLoading: balance.isLoading,
  userInfo: oidc.user.profile,
  pointsValue: balance.pointsValue,
  decimalPlaces: catalog.currencyConfiguration.decimalPlaces,
  pointsName: catalog.currencyConfiguration.pointsName
})

export default connect(mapStateToProps)(UserProfile)



// WEBPACK FOOTER //
// ./src/App/Header/UserProfile/UserProfile.js